import types from '../mutation-types';
import ConversationApi from '../../api/inbox/conversation';
import { debounce } from '@chatwoot/utils';

const state = {
  mineCount: 0,
  unAssignedCount: 0,
  allCount: 0,
  allUnresolvedUnreadConversationCount: 0,
  mineUnresolvedUnreadConversationCount: 0,
  allUnreadMessagesCount: 0,
  mineUnreadMessagesCount: 0,
  unAssignedUnreadMessagesCount: 0,
};

export const getters = {
  getStats: $state => $state,
};

// Create a debounced version of the actual API call function
const fetchMetaData = async (commit, params) => {
  try {
    const response = await ConversationApi.meta(params);
    const {
      data: { meta },
    } = response;
    commit(types.SET_CONV_TAB_META, meta);
  } catch (error) {
    // ignore
  }
};

const debouncedFetchMetaData = debounce(fetchMetaData, 500, false, 1500);
const longDebouncedFetchMetaData = debounce(fetchMetaData, 5000, false, 10000);
const superLongDebouncedFetchMetaData = debounce(
  fetchMetaData,
  10000,
  false,
  20000
);

export const actions = {
  get: async ({ commit, state: $state }, params) => {
    if ($state.allCount > 5000) {
      superLongDebouncedFetchMetaData(commit, params);
    } else if ($state.allCount > 100) {
      longDebouncedFetchMetaData(commit, params);
    } else {
      debouncedFetchMetaData(commit, params);
    }
  },
  set({ commit }, meta) {
    commit(types.SET_CONV_TAB_META, meta);
  },
  markAllRead({ commit }, { assigneeType }) {
    const stats = {
      all_unresolved_unread_conversation_count: 0,
      all_unread_messages_count: 0,
    };

    if (assigneeType === 'me' || assigneeType === 'mine_unassigned') {
      stats.mine_unresolved_unread_conversation_count = 0;
      stats.mine_unread_messages_count = 0;
    }

    commit(types.SET_CONV_TAB_META, stats);
  },
};

export const mutations = {
  [types.SET_CONV_TAB_META](
    $state,
    {
      mine_count: mineCount,
      unassigned_count: unAssignedCount,
      all_count: allCount,
      all_unresolved_unread_conversation_count:
        allUnresolvedUnreadConversationCount,
      mine_unresolved_unread_conversation_count:
        mineUnresolvedUnreadConversationCount,
      all_unread_messages_count: allUnreadMessagesCount,
      mine_unread_messages_count: mineUnreadMessagesCount,
      unassigned_unread_messages_count: unAssignedUnreadMessagesCount,
    } = {}
  ) {
    $state.mineCount = mineCount ?? $state.mineCount;
    $state.allCount = allCount ?? $state.allCount;
    $state.unAssignedCount = unAssignedCount ?? $state.unAssignedCount;
    $state.allUnresolvedUnreadConversationCount =
      allUnresolvedUnreadConversationCount ??
      $state.allUnresolvedUnreadConversationCount;
    $state.mineUnresolvedUnreadConversationCount =
      mineUnresolvedUnreadConversationCount ??
      $state.mineUnresolvedUnreadConversationCount;
    $state.allUnreadMessagesCount =
      allUnreadMessagesCount ?? $state.allUnreadMessagesCount;
    $state.mineUnreadMessagesCount =
      mineUnreadMessagesCount ?? $state.mineUnreadMessagesCount;
    $state.unAssignedUnreadMessagesCount =
      unAssignedUnreadMessagesCount ?? $state.unAssignedUnreadMessagesCount;
    $state.updatedOn = new Date();
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
